module.exports = __webpack_public_path__ + "img/SalesOfficeJP.95a8e192.png";